import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useFlags } from '../../../hooks/useFlags';
import IsPageOwner from '../../IsPageOwner/IsPageOwner';
import ManualFitnessEntry from '../../ManualFitnessEntry/ManualFitnessEntry';
import { ActivityTotalsFlags } from '../ActivityTotals';
import styles from './ActionLinks.scss';

export type ActionLinksProps = {
  switchPrimaryMeasurementType: () => void;
};

export const ActionLinks: FunctionComponent<ActionLinksProps> = props => {
  const { t } = useTranslation('common', { useSuspense: false });
  const {
    virtualFitnessEventsPreview,
    virtualFitnessEventsBleedingEdge,
  } = useFlags<ActivityTotalsFlags>();

  return (
    <div className={styles.container}>
      {virtualFitnessEventsPreview && (
        <IsPageOwner>
          <ManualFitnessEntry
            opener={({ onOpen }) => (
              <button className="jg-text--link" onClick={onOpen}>
                {t('activity.totals.actions.addProgress')}
              </button>
            )}
          />
        </IsPageOwner>
      )}
      {virtualFitnessEventsBleedingEdge && (
        <button className="jg-text--link" data-qa="activity-totals-share">
          {t('common.share')}
        </button>
      )}
      {virtualFitnessEventsPreview && (
        // NOTE: This enables switching the primary measurement type in the browser.
        // TODO: This should be removed once design of this component is complete.
        <button
          className="jg-text--link"
          onClick={props.switchPrimaryMeasurementType}
        >
          Switch measurement type
        </button>
      )}
    </div>
  );
};
